import { SiteConfigManager } from '@atlas/core';

const DefaultRtlLanguages = ['FAS', 'ARA', ''];

export const TEXT_DIRECTION = {
  LTR: 'ltr',
  RTL: 'rtl',
};

export const isRtlLanguage = ({ lang }) => {
  const languages = SiteConfigManager.getConfig('languages', []);

  return (
    !!languages.find(language => lang === language.code && language.isRtl) ||
    DefaultRtlLanguages.includes(lang)
  );
};
